module.exports = __webpack_public_path__ + "img/gallery-10.3d266b28.png";